'use strict';

var DemandTransparencyToolbarDirective = function DemandTransparencyToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/demand-transparency-toolbar.html'),
    scope: {
      cogOptionsSet: '='
    }
  };
};
DemandTransparencyToolbarDirective.$inject = [];
module.exports = DemandTransparencyToolbarDirective;